module.exports = __webpack_public_path__ + "img/logo.7ea98f88.png";